import store from '@/store';

const analyticSender = (eventTitle, eventData = {}) => {
  const { identity, name, room, room_name, type, on } =
    store.state.rooms.roomInfo || {};

  if (!window.analytics || !identity) {
    return false;
  }

  const isVector = /vmcteam.com/.test(window.location.href);

  let eventParams = {
    identity: identity.replace('host_', ''),
    name,
    room,
    room_name,
    type,
    office_number: on,
    ...eventData,
  };

  delete eventParams.kv;

  if (isVector) {
    eventParams.kv = eventData?.kv || { ...eventParams };
  }

  analytics.track(eventTitle, { ...eventParams });
};

export default analyticSender;
